export const TextInputThemeClasses = {
  dark: 'bg-[#181818] text-white placeholder:text-white focus:ring-1 focus:ring-white disabled:opacity-40 ',
  // TODO: Fix light theme classes + dynamic ring color
  light:
    'bg-white text-black placeholder:text-black/50 focus:ring-2 focus:ring-black/20 disabled:opacity-50',
};
